import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash } from 'lucide-react';
import { UserContext } from '../../../context/UserContext';
import './FamilyMemberCard.css';
import placeholderAvatar from '../../../assets/Avatars/placeholder/placeholder.png';

const avatarContext = require.context('../../../assets/Avatars', false, /\.(png|jpe?g|svg)$/);
const avatars = Object.fromEntries(
  avatarContext.keys().map(key => [key.replace('./', ''), avatarContext(key)])
);

function FamilyMemberCard({ member, onEdit, onDelete }) {
    const { user } = useContext(UserContext);
    const isParent = member.role === 'parent';
    const navigate = useNavigate();

    const handleCardClick = () => {
        if (!isParent) {
            navigate(`/family/${member.name}`);
        }
    };

    const handleActionClick = (e, action) => {
        e.stopPropagation();
        action();
    };

    const isCurrentUser = user.details && user.details.user_id === member.parentId;

    return (
        <div 
            className={`family-member-card ${isParent ? 'parent-card' : 'child-card'}`}
            onClick={handleCardClick}
            style={{ cursor: isParent ? 'default' : 'pointer' }}
        >
            {!isParent && (
                <img 
                    src={avatars[member.avatarUrl] || placeholderAvatar} 
                    alt={`${member.name}'s Avatar`}
                    className="family-member-avatar"
                />
            )}
            <div className={`family-member-info ${isParent ? 'parent-info' : ''}`}>
                <h3 className="family-member-name">{member.display_name || member.name}</h3>
            </div>
            <div className="family-member-actions">
                <button 
                    className="icon-button edit-button" 
                    onClick={(e) => handleActionClick(e, onEdit)} 
                    aria-label="Edit"
                >
                    <Edit size={24} />
                </button>
                {!isCurrentUser && (
                    <button 
                        className="icon-button delete-button" 
                        onClick={(e) => handleActionClick(e, onDelete)} 
                        aria-label="Delete"
                    >
                        <Trash size={24} />
                    </button>
                )}
            </div>
        </div>
    );
}

export default FamilyMemberCard;